import {Inject, injectable} from 'inversify-props';
import {TypedJSON} from 'typedjson';

import {Connection} from '@/model/network/connection/Connection';

import {INetworkConnectionService} from '@/services/network/INetworkConnectionService';
import {IApiService} from '@/services/IApi.service';

@injectable()
export class NetworkConnectionService implements INetworkConnectionService {

  @Inject(Symbol.for('IApiService'))
  private apiService!: IApiService;

  private path: string = '/network/connection';

  public async readAll(): Promise<Connection[]> {
    const connectionsData = await this.apiService.get(this.path);
    return connectionsData.map((c: any) => Connection.Serializer.parse(c));
  }

  public async read(id: string): Promise<Connection> {
    return Connection.Serializer.parse(await this.apiService.get(`${this.path}/${id}`))!;
  }

  public async disconnect(id: string): Promise<void> {
    return this.apiService.post(`${this.path}/disconnect/${id}`, null, {
      timeout: this.apiService.Timeout + 5000,
    });
  }

  public async subscribeState(id: string): Promise<void> {
    return this.apiService.post(`${this.path}/state/subscribe/${id}`, null);
  }

  public async unsubscribeState(id: string): Promise<void> {
    return this.apiService.post(`${this.path}/state/unsubscribe/${id}`, null);
  }

}
